export const defaultState = {
	name: '',
	account: '',
	userAccess: 30,
	user: null,
	leepUsername: '',
	leepPassword: '',
	fflbossPosCombo: false,
	locations: [],
	states: [],
	kiosks: [],
	locationsCount: 0,
	hasPawnModule: false,
	hasSecurityModule: false,
	hasNFAModule: false,
	hasManufacturingModule: false,
	hasImageCompressionModule: false,
	kioskMode: null,
	kioskLocation: null,
	kioskLocationBinaryId: null,
	showMobileSidebar: false,
	isAdmin: false,
	hasPin: false,
	isLockedDown: false,
};
